export default {
	name: "link-customer-to-depot-discount-group-modal",
	props: ["heading", "modalId", "showModal", "customerDiscountGroupId", "unlinkedCompanyId"],
	emits: ["okClicked", "onCustomersLinkedOrUnlinked"],
	data() {
		return {
			companiesLinkedAndUnlinkedToDiscountGroup: [],
			companiesLinkedAndUnlinkedToDiscountGroupHeadings: [
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "Company Registration Number",
					field: "companyRegistrationNumber"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				},
			],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			searchQuery: null,
			customersToLink: [],
			customersToUnlink: [],
			hasDonePaging: false,
			newCustomerIdsToLink: []
		};
	},
	methods: {
		getCompaniesLinkedAndUnlinkedToDepotDiscountGroup(){
			this.loading = true;
			var customerDiscountGroupId = this.customerDiscountGroupId === null ? 0 : this.customerDiscountGroupId;
			orderService.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup(customerDiscountGroupId, this.pagingDetails.pageNumber, this.pagingDetails.pageSize, this.searchQuery).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.companiesLinkedAndUnlinkedToDiscountGroup = successResponse.data.result;
						
						console.log("hasDonePaging", this.hasDonePaging);
						if(this.hasDonePaging || this.customersToLink.length > 0){
							console.log("customersToLink", this.customersToLink);
							for(let i = 0; i < this.companiesLinkedAndUnlinkedToDiscountGroup.length; i++) {
								this.companiesLinkedAndUnlinkedToDiscountGroup[i].isLinked = this.customersToLink.find(x => x.companyId === this.companiesLinkedAndUnlinkedToDiscountGroup[i].companyId) !== undefined;
							}
						}
						console.log("companiesLinkedAndUnlinkedToDiscountGroup", this.companiesLinkedAndUnlinkedToDiscountGroup);
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						this.onModalSaveClick(false);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompaniesLinkedToDepotDiscountGroup(){
			this.loading = true;
			let request = {
				depotDiscountGroupId: this.customerDiscountGroupId,
				isActive: true
			};
			orderService.getCompaniesLinkedToDepotDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customersToLink = successResponse.data.result;
						this.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.hasDonePaging = true;
			this.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup();
		},
		onFilterSearchClicked(){
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.hasDonePaging = true;
			this.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup();
		},
		onCompanyCheckOrUncheck(companyId){
			let company = this.companiesLinkedAndUnlinkedToDiscountGroup.find(x => x.companyId === companyId);
			company.isLinked = !company.isLinked;

			if(company.isLinked){
				if(this.customersToUnlink.find(x => x.companyId === companyId) !== undefined){
					this.customersToUnlink = this.customersToUnlink.filter(x => x.companyId !== companyId);
				}
				this.newCustomerIdsToLink.push(companyId);
			}
			else{
				if(this.customersToLink.find(x => x.companyId === companyId) !== undefined){
					this.customersToLink = this.customersToLink.filter(x => x.companyId !== companyId);
				}
				this.newCustomerIdsToLink = this.newCustomerIdsToLink.filter(x => x !== companyId);
			}

			var customersToLink = this.companiesLinkedAndUnlinkedToDiscountGroup.filter(x => x.isLinked);
			var customersToUnlink = this.companiesLinkedAndUnlinkedToDiscountGroup.filter(x => !x.isLinked);

			for(let i = 0; i < customersToLink.length; i++){
				if(this.customersToLink.find(x => x.companyId === customersToLink[i].companyId) === undefined){
					this.customersToLink.push(customersToLink[i]);
				}
			}

			for(let j = 0; j < customersToUnlink.length; j++) {
				if (this.customersToUnlink.find(x => x.companyId === customersToUnlink[j].companyId) === undefined) {
					this.customersToUnlink.push(customersToUnlink[j]);
				}
			}

			// this.$emit("onCustomersLinkedOrUnlinked", {
			// 	customersToLink: customersToLink,
			// 	customersToUnlink: customersToUnlink,
			// 	isSaving: false
			// });
		},
		onModalCloseClick(){
			//this.customersToLink = []
			//this.customersToUnlink = [];
			this.searchQuery = null;
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.hasDonePaging = false;
			for(let i = 0; i < this.companiesLinkedAndUnlinkedToDiscountGroup.length; i++) {
				for (let j = 0; j < this.newCustomerIdsToLink.length; j++) {
					if (this.companiesLinkedAndUnlinkedToDiscountGroup[i].companyId === this.newCustomerIdsToLink[j]) {
						this.companiesLinkedAndUnlinkedToDiscountGroup[i].isLinked = false;
						this.customersToLink = this.customersToLink.filter(x => x.companyId !== this.newCustomerIdsToLink[j]);
						if (this.customersToUnlink.find(x => x.companyId === this.newCustomerIdsToLink[j]) === undefined) {
							this.customersToUnlink.push(this.companiesLinkedAndUnlinkedToDiscountGroup[i]);
						}
					}
				}
			}
			// this.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup();
			// this.$emit("onCustomersLinkedOrUnlinked", {
			// 	customersToLink: [],
			// 	customersToUnlink: [],
			// 	isSaving: false
			// });
			this.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup();
			this.$emit("okClicked", true);
		},
		onModalSaveClick(isSaving= true){
			this.newCustomerIdsToLink = [];
			if(this.customersToUnlink.length === 0 && this.customersToLink.length === 0) {
				var customersToLink = this.companiesLinkedAndUnlinkedToDiscountGroup.filter(x => x.isLinked);
				var customersToUnlink = this.companiesLinkedAndUnlinkedToDiscountGroup.filter(x => !x.isLinked);
				console.log("customersToLink", this.customersToLink);

				this.customersToUnlink.push(...customersToUnlink);
				this.customersToLink.push(...customersToLink);
				
				this.$emit("onCustomersLinkedOrUnlinked", {
					customersToLink: customersToLink,
					customersToUnlink: customersToUnlink,
					isSaving: isSaving
				});
			}
			else{
				this.$emit("onCustomersLinkedOrUnlinked", {
					customersToLink: this.customersToLink,
					customersToUnlink: this.customersToUnlink,
					isSaving: isSaving
				});
			}
			
			if(isSaving) {
				this.hasDonePaging = false;
				this.searchQuery = null;
				this.pagingDetails = {
					pageNumber: 1,
					pageSize: 10,
					totalPages: 1
				};
				this.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup();
			}
		}
	},
	mounted: function () {
		
	},
	watch:{
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
					this.hasDonePaging = false;
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		customerDiscountGroupId:{
			handler: function () {
				//this.getCustomerDiscountGroup();
				console.log("customerDiscountGroupId", this.customerDiscountGroupId);
				if(this.customerDiscountGroupId !== null && this.customerDiscountGroupId !== undefined){
					if(this.customerDiscountGroupId > 0){
						this.getCompaniesLinkedToDepotDiscountGroup();
					}
					else{
						this.getCompaniesLinkedAndUnlinkedToDepotDiscountGroup();
					}
				}
			},
			immediate: true,
			deep: true
		},
		unlinkedCompanyId:{
			handler: function () {
				if(this.unlinkedCompanyId !== null && this.unlinkedCompanyId !== undefined){
					let company = this.companiesLinkedAndUnlinkedToDiscountGroup.find(x => x.companyId === this.unlinkedCompanyId);
					company.isLinked = false;
					this.customersToLink = this.customersToLink.filter(x => x.companyId !== this.unlinkedCompanyId);
					if(this.customersToUnlink.find(x => x.companyId === this.unlinkedCompanyId) === undefined){
						this.customersToUnlink.push(company);
					}
				}
			},
			immediate: true,
			deep: true
		}
	}
};